var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenSeason(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4829_382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 1.66602C5.40033 1.66602 1.66699 5.39935 1.66699 9.99935C1.66699 14.5993 5.40033 18.3327 10.0003 18.3327C14.6003 18.3327 18.3337 14.5993 18.3337 9.99935C18.3337 5.39935 14.6003 1.66602 10.0003 1.66602ZM9.16699 16.6077C5.87533 16.1993 3.33366 13.3993 3.33366 9.99935C3.33366 9.48268 3.40033 8.99102 3.50866 8.50768L7.50033 12.4993V13.3327C7.50033 14.2493 8.25033 14.9993 9.16699 14.9993V16.6077ZM14.917 14.491C14.7003 13.816 14.0837 13.3327 13.3337 13.3327H12.5003V10.8327C12.5003 10.3743 12.1253 9.99935 11.667 9.99935H6.66699V8.33268H8.33366C8.79199 8.33268 9.16699 7.95768 9.16699 7.49935V5.83268H10.8337C11.7503 5.83268 12.5003 5.08268 12.5003 4.16602V3.82435C14.942 4.81602 16.667 7.20768 16.667 9.99935C16.667 11.7327 16.0003 13.3077 14.917 14.491Z",
    fill: "#030303"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4829_382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSeason);
export default __webpack_public_path__ + "static/media/open_season.74c31d09c558f7bf098e4646e28d57aa.svg";
export { ForwardRef as ReactComponent };